var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "cart_svg__icon cart_svg__icon--cart",
    viewBox: "0 0 31 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cart_svg__svg-icon cart_svg__cart-icon--odd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 21.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 21.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 1.5h5c.6 0 1.1.4 1.1 1l1.7 13c.1.5.6 1 1.1 1h15c.5 0 1.2-.4 1.4-.9l3.3-8.1c.2-.5-.1-.9-.6-.9H12"
  }))));
};

export { SvgCart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiBpY29uLS1jYXJ0IiB2aWV3Qm94PSIwIDAgMzEgMjQiPgogIDxnIGNsYXNzPSJzdmctaWNvbiBjYXJ0LWljb24tLW9kZCI+CiAgICA8Y2lyY2xlIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgY3g9IjIyLjUiIGN5PSIyMS41IiByPSIxIj48L2NpcmNsZT4KICAgIDxjaXJjbGUgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBjeD0iOS41IiBjeT0iMjEuNSIgcj0iMSI+PC9jaXJjbGU+CiAgICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0wLDEuNWg1YzAuNiwwLDEuMSwwLjQsMS4xLDFsMS43LDEzCiAgICAgIGMwLjEsMC41LDAuNiwxLDEuMSwxaDE1YzAuNSwwLDEuMi0wLjQsMS40LTAuOWwzLjMtOC4xYzAuMi0wLjUtMC4xLTAuOS0wLjYtMC45SDEyIj48L3BhdGg+CiAgPC9nPgo8L3N2Zz4K";